export enum Sort {
    ASC = 'ASC',
    DESC = 'DESC',
    EMPTY = '',
}
